module.exports = __webpack_public_path__ + "static/media/template_s7.12071a6e.jpg";